import { useGetFullInfo, useGetUserLevels } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';

/**
 * @returns percentageScaleValue: Значение для PercentageScale, который используется в местах, в которых надо отображать только уровень пользователя.
 * @returns currentLevelName: Название текущего уровня.
 * @returns formattedLevelPointsString: Отформатированное значение очков уровня.
 */

export const useGetLevelInfo = () => {
  const { t } = useTranslation();
  const { allLevels } = useGetUserLevels();
  const { fullInfo } = useGetFullInfo();

  const userLevel = fullInfo?.level;

  const userPoints = fullInfo?.points;

  const levelInfo = allLevels?.[userLevel - 1];

  const nextLevelInfo = allLevels?.[userLevel];

  const levelPointsFrom = levelInfo?.levelInfo?.fromPoints;

  const levelPointsTo = nextLevelInfo?.levelInfo?.fromPoints - 1;

  const currentLevelName = allLevels?.[userLevel - 1]?.title;

  const percentageScaleValue = () => {
    if(userLevel === 0) return ((userPoints) / (levelPointsTo)) * 100
    return ((userPoints - levelPointsFrom) / (levelPointsTo - levelPointsFrom)) * 100;
  };

  const formattedLevelPointsString = `${userPoints} ${levelPointsTo ? `/ ${levelPointsTo}` : ''} ${t('general.wizebetsPoints')}`;

  return { percentageScaleValue, currentLevelName, formattedLevelPointsString };
};
